// function to calculate width for each element
export var spendPercentage = function (firstAmount, otherAmount) { return (otherAmount / firstAmount) * 100; };
